module.exports = __webpack_public_path__ + "static/media/599.768 (2).260feea2.pdf";